const MapControlType = {
	PAN: "Pan (P) (Default) ",
	BOX_SELECT: "Box Select (B)",
	ADD_CUSTOM_GEOJSON: "Add Custom Geometry",
	ADD_POLYLINE: "Add Line",
	ADD_POLYGON: "Add Polygon",
	ADD_RECTANGLE: "Add Rectangle",
	ADD_MARKER: "Add Marker",
	DELETE_CUSTOM_GEOJSON: "Delete Custom Geometry",
	LNGLAT_PICKER: "Pick LngLat (L)",
	BOX_PICKER: "Draw Box"
};
export default MapControlType;
